import { Routes } from '@angular/router';
const ɵ0 = () => import("./folder/folder.module.ngfactory").then(m => m.FolderPageModuleNgFactory), ɵ1 = () => import("./home/home.module.ngfactory").then(m => m.HomePageModuleNgFactory), ɵ2 = () => import("./statistiques/statistiques.module.ngfactory").then(m => m.StatistiquesPageModuleNgFactory), ɵ3 = () => import("./inprogress/inprogress.module.ngfactory").then(m => m.InprogressPageModuleNgFactory), ɵ4 = () => import("./result/result.module.ngfactory").then(m => m.ResultPageModuleNgFactory);
const routes = [
    {
        path: '',
        redirectTo: 'folder/Questionnaire',
        pathMatch: 'full'
    },
    {
        path: 'folder/:id',
        loadChildren: ɵ0
    },
    {
        path: 'home',
        loadChildren: ɵ1
    },
    {
        path: 'statistiques',
        loadChildren: ɵ2
    },
    {
        path: 'inprogress',
        loadChildren: ɵ3
    },
    {
        path: 'result',
        loadChildren: ɵ4
    },
];
export class AppRoutingModule {
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4 };
